import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_VENDOR,
  DELETE_VENDOR,
  UPDATE_VENDOR,
  ADD_NEW_VENDOR,
} from "./actionType";

import {
  getVendorSuccess,
  getVendorFail,
  deleteVendorSuccess,
  deleteVendorFail,
  updateVendorSuccess,
  updateVendorFail,
  addVendorSuccess,
  addVendorFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveVendorApi,
  getVendorApi,
  updateVendorApi,
  deleteVendorApi,
  addNewVendorApi
} from "../../helpers/backend_helper";

function* getVendor({ payload: vendor }) {
  try {
    const response = yield call(getVendorApi, vendor);
    yield put(getVendorSuccess(GET_VENDOR, response.data));
  } catch (error) {
    yield put(getVendorFail(GET_VENDOR, error));
  }
}

function* onUpdateVendor({ payload: vendor }) {
  try {
    if (vendor.setApprove) {
      const response = yield call(approveVendorApi, vendor);
      yield put(updateVendorSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateVendorApi, vendor);
      yield put(updateVendorSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateVendorFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteVendor({ payload: vendor }) {
  try {
    const response = yield call(deleteVendorApi, vendor);
    yield put(deleteVendorSuccess({ vendor, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteVendorFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewVendor({ payload: vendor }) {
  try {
    const response = yield call(addNewVendorApi, vendor);
    yield put(addVendorSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addVendorFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetVendor() {
  yield takeEvery(GET_VENDOR, getVendor);
}

export function* watchUpdateVendor() {
  yield takeEvery(UPDATE_VENDOR, onUpdateVendor);
}

export function* watchDeleteVendor() {
  yield takeEvery(DELETE_VENDOR, onDeleteVendor);
}

export function* watchAddNewVendor() {
  yield takeEvery(ADD_NEW_VENDOR, onAddNewVendor);
}

function* vendorSaga() {
  yield all([
    fork(watchGetVendor),
    fork(watchDeleteVendor),
    fork(watchUpdateVendor),
    fork(watchAddNewVendor)
  ]);
}

export default vendorSaga;
